export const doctorCalendarTypes = {
    SET_TIME_SLOTS:'SET_TIME_SLOTS',
    DELETE_TIME_SLOTS:'DELETE_TIME_SLOTS',
    SET_DATE_ON_LEAVE:'SET_DATE_ON_LEAVE',
    DELETE_DATE_ON_LEAVE:'DELETE_DATE_ON_LEAVE'
}